// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";
import Notification from "@stimulus-components/notification";

application.register("notification", Notification);

import ModalsController from "./modals_controller";
application.register("modals", ModalsController);

import LoadingBarController from "./loading_controller";
application.register("shared--loading", LoadingBarController);

import ListingController from "./listing_controller";
application.register("shared--listing", ListingController);

import SearchFormController from "./search_form_controller";
application.register("search_form", SearchFormController);

import ThemeController from "./theme_controller";
application.register("theme", ThemeController);

import KanbanController from "./kanban_controller";
application.register("kanban", KanbanController);

import DropdownController from "./dropdown_controller";
application.register("dropdown", DropdownController);

import NavbarController from "./navbar_controller";
application.register("navbar", NavbarController);

import NestedDropdownController from "./nested_dropdown_controller";
application.register("nested-dropdown", NestedDropdownController);

import FilterPreserveController from "./filter_preserve_controller";
application.register("filter-preserve", FilterPreserveController);

import TableSortController from "./table_sort_controller";
application.register("table-sort", TableSortController);

import StatisticsConfigController from "./ministy_scales/statistics_config_controller";
application.register("statistics-config", StatisticsConfigController);

import MemberStatisticsController from "./ministy_scales/member_statistics_controller";
application.register(
  "ministy-scales--member-statistics",
  MemberStatisticsController
);
